<template>
  <div class="queryOutPay page-container">
    <div class="page-title">
      {{ $t('customerService.payout_search') }}
    </div>
    <!-- <div class="filter-section-container">
      <div class="filter-fixed">
        <span class="filter-fixed-title">{{ $t('data.filter_section') }}</span>
        <i
          class="el-icon-arrow-down filter-fixed-arrow"
          :class="{'fiter-icon-arrow-route':!showFilterContent}"
          @click="onClickFixedArrow"
        />
      </div>
      <el-collapse-transition>
        <div v-show="showFilterContent">
          <div id="filter-content" class="filter-content">
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.merchant_order_id') }}:</div>
              <el-input v-model="search.mch_order_id" size="small" type="text" class="filter-item-value" clearable />
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.transaction_id') }}:</div>
              <el-input v-model="search.transaction_id" size="small" type="text" class="filter-item-value" clearable />
            </div>
            <div class="filter-item" />
          </div>
          <div class="filter-operate">
            <div class="filter-operate-left" />
            <div class="filter-operate-right">
              <el-button class="search-btn mb-10" size="small" @click="onClickReset">{{ $t('components.re_set') }}</el-button>
              <el-button class="search-btn" type="primary" size="small" icon="el-icon-search" @click="onClickSearchBtn">{{ $t('components.search') }}</el-button>
            </div>

          </div>
        </div>

      </el-collapse-transition>
    </div> -->
    <div class="filter-container">
      <!--交易id  -->
      <span class="search-label">{{ $t('customerService.transaction_id') }}:</span>
      <el-input v-model.trim="search.transaction_id" size="small" type="text" class="search-frame" clearable />

      <!--客户订单号  -->
      <span class="search-label">{{ $t('customerService.merchant_order_id') }}:</span>
      <el-input v-model.trim="search.mch_order_id" size="small" type="text" class="search-frame" clearable />

      <!-- 查询 -->
      <el-button class="search-btn" type="primary" size="small" icon="el-icon-search" @click="onClickSearchBtn">{{ $t('components.search') }}</el-button>
    </div>

    <div class="tableContainer">
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >

        <el-table-column :label="$t('customerService.transaction_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_id }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.merchant_order_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.merchant_order_id }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.recipient_channel')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.recipient_channel }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="isShowFXRow" :label="$t('data.source_amount')" align="center">
          <template slot-scope="scope">
            <span> {{ scope.row.source_amount | toDivideWithDot }} {{ scope.row.source_currency }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.destination_amount')" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.transaction_type === TRANSACTION_TYPE_FX">
              {{ scope.row.destination_amount | toDivideWithDot }} {{ scope.row.destination_currency }}
            </div>
            <div v-else>
              {{ scope.row.po_trans_amount | toDivideWithDot }}
              <span v-if="isShowFXRow">{{ $store.getters.currency }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchant.service_fee')" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.transaction_type === TRANSACTION_TYPE_FX">{{ scope.row.mch_foreign_exchange_fee_resp.fee_split | toDivideWithDot }} {{ scope.row.mch_foreign_exchange_fee_resp.fee_split_currency }}</div>
            <div v-else>{{ scope.row.fee_split | toDivideWithDot }}  <span v-if="isShowFXRow">{{ $store.getters.currency }}</span></div>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.po_trans_status')" align="center">
          <template slot-scope="scope">
            <el-tag class="tag-status" :type="getPoTransactionStatusStyle(scope.row.po_trans_status)">{{ getPoTransactionStatusLabel(scope.row.po_trans_status,scope.row.refund_type) }}</el-tag>
          </template>
        </el-table-column>

        <!-- <el-table-column :label="$t('customerService.app_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.app_name }}</span>
          </template>
        </el-table-column> -->

        <el-table-column :label="$t('merchantAccount.create_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_create_time }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.complete_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_return_time }}</span>
          </template>
        </el-table-column>

        <!--操作-->
        <el-table-column :label="$t('components.operation')" align="center">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('components.detail') }}</span> <br>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailBtn(scope.row)" />
            </el-tooltip>

          </template>
          <!-- <template slot-scope="scope">
            <div>
              <el-popover
                v-model="scope.row.popVisible"
                placement="bottom"
                width="280"
                popper-class="refundPopover_container"
              >
                <p class="queryOutPay_popover_title">Refund instructions</p>
                <el-input
                  v-model="scope.row.refundTxt"
                  class="queryOutPay_textarea"
                  type="textarea"
                  :rows="2"
                  placeholder="Please enter the content"
                />
                <div class="queryOutPay_btn-container">
                  <el-button class="queryOutPay_size-btn" round @click="onClickCancal(scope.$index)">{{ $t('components.cancel') }}</el-button>
                  <el-button class="queryOutPay_size-btn" type="primary" round @click="onClickRefundBtn(scope.$index)">{{ $t('components.submit') }}</el-button>
                </div>
                <el-button slot="reference" type="primary" size="mini" disabled>{{ $t('customerService.refund') }}</el-button>
              </el-popover>
            </div>
          </template> -->
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-container">
      <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="confirm" />
    </div>

    <po-details-modal ref="poMentDetailsModal" :detail-id="detailId" />
  </div>
</template>

<script>

import { fetchPoOrderList, submitRefundInstruction } from '@/api/customer-service/customer-service'
import { poTransStatusWithRefundMap } from '@/utils/maps'

export default {
  name: 'Customer_Service_Query_Payout',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    PoDetailsModal: () => import('./components/Modal/PoDetailsModal')
  },
  data() {
    this.TRANSACTION_TYPE_FX = 4
    return {
      showFilterContent: true,
      search: {
        mch_order_id: ''
      },
      tableData: [],
      payTypeArr: [], // 支付类型数组
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      detailId: 0
    }
  },
  computed: {
    getPoTransactionStatusLabel() {
      return function(value, refund_type) {
        if (refund_type === 2) {
          value = 99
        }
        return poTransStatusWithRefundMap(value).label
      }
    },
    getPoTransactionStatusStyle() {
      return function(value) {
        return poTransStatusWithRefundMap(value).type
      }
    },
    isShowFXRow() {
      return this.tableData?.some(item => item.transaction_type === this.TRANSACTION_TYPE_FX)
    }
  },
  created() {
  },
  methods: {
    onClickDetailBtn(row) {
      this.detailId = row.transaction_id
      this.showPayDetailModal()
    },
    handleFilter(params = {}) {
      Object.assign(params, this.search)
      const newParam = this.filterEmptyParams(params)
      this.getPoOrderList(newParam)
    },
    // 过滤参数
    filterEmptyParams(params) {
      const newParam = {}
      // 过滤属性为空的值
      Object.keys(params).filter(item => params[item] || params[item] === 0).forEach((key) => {
        let value = params[key]
        if (typeof value === 'string') {
          value = value.trim()
        }
        newParam[key] = value
      })
      return newParam
    },
    showPayDetailModal() {
      this.$refs.poMentDetailsModal.changModalStatus(true)
    },
    onClickCancal(index) {
      this.tableData[index].refundTxt = ''
      this.tableData[index].popVisible = false
    },
    onClickRefundBtn(index) {
      // 请求接口
      submitRefundInstruction().then((res) => {
        if (res.code === 10000) {
          this.tableData[index].refundTxt = ''
          this.tableData[index].popVisible = false
        }
      }).catch((err) => {
        console.error('eee', err)
        this.tableData[index].refundTxt = ''
        this.tableData[index].popVisible = false
      })
    },
    onClickSearchBtn() {
      const { mch_order_id, transaction_id } = this.search
      if (!mch_order_id && !transaction_id) {
        this.$message.warning('At least one parameter')
        return
      }
      this.handleFilter(this.search)
    },
    // 获取请求列表
    getPoOrderList(params = {}) {
      this.listLoading = true
      fetchPoOrderList(params).then(res => {
        this.tableData = res.data.list || []
        this.listQuery.total = res.data.total
        this.listQuery.page = params.page ? params.page : 1
      }).finally(() => {
        this.listLoading = false
      })
    },
    confirm() {
      const params = {
        page: this.listQuery.page
      }
      this.handleFilter(params)
    },
    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {}
    }
  }
}
</script>

<style lang="scss" scoped>
.search-label{
  display: inline-block;
  padding-right: 5px;
  font-size: 14px;
  font-weight: 500;
  color: #606266;
  font-family: 'Inter-Medium';
}
// 由于使用popover是挂着根节点上，所以样式只能单独写
.queryOutPay_btn-container{
  margin: 0 50px;
  display: flex;
  justify-content: space-between;
}
.queryOutPay_size-btn{
  width: 80px;
  height: 28px;
  line-height: 6px;
}
.queryOutPay_popover_title{
  text-align: center;
  color: #606266;
}
.queryOutPay_textarea{
  margin-bottom: 20px;
}
.queryOutPay{
  .filter-container{
    text-align: right;
    padding: 40px 0 24px 24px;
  }

  .pagination-container{
    padding: 20px;
    margin-top: 0;
  }
   .search-frame {
      width: 256px;
      margin-bottom: 10px;
      margin-right: 16px;
  }
  // .search-btn {
  //   margin-left: 10px;
  // }
  .tag-status{
    // text-decoration: underline;
    // cursor: pointer;
  }
}

</style>
